import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import "./style.scss";
import { useTranslation } from "react-i18next";

const CardName: React.FC = () => {
  const userData = useSelector((state: State) => state.auth.userData);
  const { t } = useTranslation();
  return (
    <React.Fragment>
      {userData.captionDepositBalance !== "0.00" && (
        <h3>
          {userData.captionDepositBalance} {t("zl")}
        </h3>
      )}
      {userData.captionBalanceI !== "0.00" && (
        <h3>
          {userData.descriptionBalanceI} {t("zl")}
        </h3>
      )}
      {userData.captionBalanceII !== "0.00" && (
        <h3>
          {userData.descriptionBalanceII} {t("zl")}
        </h3>
      )}
      {userData.captionBalanceIII !== "0.00" && (
        <h3>
          {userData.descriptionBalanceIII} {t("zl")}
        </h3>
      )}
    </React.Fragment>
  );
};

export default CardName;
